var _sodipodinamedview, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApprove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 210 220",
    stroke: "#000000",
    fill: "#000000",
    id: "svg885",
    sodipodidocname: "approve.svg",
    inkscapeversion: "1.1.2 (0a00cf5339, 2022-02-04)",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodinamedview || (_sodipodinamedview = /*#__PURE__*/React.createElement("sodipodinamedview", {
    id: "namedview6",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapepageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0,
    showgrid: "false",
    inkscapezoom: 3.85,
    inkscapecx: 105.06494,
    inkscapecy: 109.87013,
    "inkscapewindow-width": 1920,
    "inkscapewindow-height": 1019,
    "inkscapewindow-x": 0,
    "inkscapewindow-y": 24,
    "inkscapewindow-maximized": 1,
    "inkscapecurrent-layer": "svg885"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs889"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 3.7882374,12.102301 H 134.32214 L 108.84542,37.580279 H 29.266217 V 177.70919 H 182.13412 V 99.876501 L 207.6121,74.398521 V 203.18717 H 3.7882374 Z",
    id: "path881",
    style: {
      strokeWidth: 1.2739
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 81.043847,69.793371 103.28231,91.268771 183.96726,7.7149932 207.20191,30.152178 125.85071,114.39513 104.0785,136.9406 58.606667,93.028021 Z",
    id: "path883",
    style: {
      strokeWidth: 1.2739
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/approve.e597abb4dee33aa2bf93978185a8f4a8.svg";
export { ForwardRef as ReactComponent };